import type { PasswordRequirement } from '@libs/enums';
import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { ItemName, Locale, Numeric, ValueSet } from '@ps-smart-cp/ppfw-client';

interface Schema {
  minDigitNumber: string;
  passwordRequirements: Set<PasswordRequirement>;
}

interface Record {
  minDigitNumber: string;
  passwordRequirements: string[];
}

const attributes = {
  minDigitNumber: Numeric.of(6, 99, 0, true),
  passwordRequirements: ValueSet.new(),
} satisfies ItemAttributes<Schema>;

const names = {
  minDigitNumber: ItemName.of([Locale.ja, '最小桁数'], [Locale.en, 'minimum digit number']),
  passwordRequirements: ItemName.of([Locale.ja, 'パスワード要件'], [Locale.en, 'password requirement']),
} satisfies ItemNames<Schema>;

const titleNames = {
  passwordPolicySetting: ItemName.of(
    [Locale.ja, 'パスワードポリシー設定'],
    [Locale.en, 'Password Policy Settings'],
  ),
};

const passwordPolicySetting = {
  attributes,
  names,
  titleNames,
};

interface PasswordPolicySetting {
  schema: Schema;
  record: Record;
}

export { passwordPolicySetting };
export type { PasswordPolicySetting };
